





















import { Component, Vue } from "vue-property-decorator";

import Button from "@/components/Button.vue";
import RandomList from "@/components/RandomList.vue";

import Categories from "./Categories.vue";

@Component({
  components: {
    Button,
    Categories,
    RandomList,
  },
})
export default class Home extends Vue {
  name = "home"
  data() {
    return {
      buttonText: "Show me something!",
    }
  }
  // Redirect to random page
  redirect() {
    this.$router.push('Random');
  }
}

